
<template>
  <div class="addExpenseRecord">
    <div class="add-content-container">
      <div class="add-titieMain">
        <div class="add-title-container">费用支出单</div>
        <div class="add-content">
          <div class="operation-btn">
            <el-button
              size="small"
              class="del"
              @click="onDelete"
              :disabled="enableTable || !edit"
              >删除</el-button
            >
            <el-button
              size="small"
              class="add"
              @click="onAdd"
              :disabled="enableTable || !edit"
              >增加</el-button
            >
            <el-button
              size="small"
              class="alter"
              @click="onAlter"
              :disabled="enableTable || !edit"
              >修改</el-button
            >
            <el-button
              size="small"
              class="save"
              @click="onSave"
              :disabled="!enableTable || !edit"
              >保存</el-button
            >
            <el-button
              size="small"
              class="cancel"
              @click="onRollBack"
              :disabled="!enableTable || !edit"
              >撤销</el-button
            >
            <el-button
              size="small"
              class="close"
              @click="closeView"
              >关闭</el-button
            >
          </div>
          <div class="custom-search-container">
            <div
              class="custom-search-box base-search-box"
              :class="{ 'has-pond': order.pond != '' }"
            >
              <div class="custom-search-box-warpper base-search-box-wrapper">
                <span><font style="opacity: 0">啊</font>基地</span>
                <!--  || Boolean(order.employeeId) -->
                <el-select
                  v-model="order.fishBaseId"
                  filterable
                  placeholder="请选择"
                  size="small"
                  @change="baseChange"
                  :disabled="
                    Boolean(orderId) || !edit
                  "
                >
                  <el-option
                    v-for="(item, index) in baseLists"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
                <div class="base-pond-box">
                  <!--  || Boolean(order.employeeId) -->
                  <el-select
                    class="header-pond-select"
                    v-model="order.pond"
                    filterable
                    placeholder="请选择"
                    size="small"
                    @change="topPondChange"
                    :disabled="
                      Boolean(orderId) || !edit
                    "
                  >
                    <el-option
                      v-for="(item, index) in topPondList"
                      :key="index"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                  <div class="header-batch-area">
                    <template v-if="order.pond != ''">
                      <span class="header-batch-label">周期</span>
                      <el-select
                        v-if="!orderId"
                        class="header-batch-select"
                        v-model="order.fishBatchId"
                        size="small"
                        placeholder="请选择"
                        :disabled="!edit"
                        @change="headerBatchChange"
                      >
                        <el-option
                          v-for="item in pondBatchList"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                      <span v-else class="header-batch-text">{{ order.fishBatch }}</span>
                    </template>
                  </div>
                </div>
              </div>
              <div class="custom-search-box-warpper header-date-wrapper">
                <span><font style="opacity: 0">啊啊</font>日期</span>
                <el-date-picker
                  size="small"
                  :disabled="!edit"
                  v-model="order.dataDate"
                  type="date"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerTimeOptions"
                >
                </el-date-picker>
              </div>
              <div class="custom-search-box-warpper">
                <span>流水号</span>
                <el-input
                  placeholder="请输入流水号"
                  v-model="order.number"
                  size="small"
                  disabled
                >
                </el-input>
              </div>
            </div>
            <div
              class="custom-search-box"
              :class="{ 'has-pond': order.pond != '' }"
            >
              <div class="custom-search-box-warpper">
                <span>负责人</span>
                <el-select
                  v-model="order.employeeId"
                  filterable
                  placeholder="请选择"
                  :disabled="Boolean(orderId)"
                  size="small"
                  @change="changeEmlopyee"
                >
                  <el-option
                    v-for="(item, index) in employeesList"
                    :key="index"
                    :label="item.realName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="custom-search-box-warpper">
                <span>费用名称</span>
                <el-select
                  v-model="order.costTypeId"
                  placeholder="请选择"
                  :disabled="(!order.employeeId && !orderId) || isDisCost"
                  @change="changeCostType"
                >
                  <el-option-group
                    v-for="group in costTypeV2List"
                    :key="group.id"
                    :label="group.name"
                  >
                    <el-option
                      v-for="item in group.details"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
                <!-- <el-select
                  v-model="order.pond"
                  filterable
                  placeholder="请选择"
                  size="small"
                  @change="topPondChange"
                  :disabled="Boolean(orderId) || !edit"
                >
                  <el-option
                    v-for="(item, index) in topPondList"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select> -->
              </div>
              <div class="custom-search-box-warpper">
                <span>金额</span>
                <el-input
                  placeholder="请输入金额"
                  v-model="order.price"
                  :disabled="(!order.employeeId && !orderId) || isDisCost"
                  @input="calculateDetailAmount"
                  size="small"
                >
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-container">
        <table-ex :showIndex="true" :enable="enableTable && edit">
          <thead-ex>
            <th-ex v-if="order.pond == ''">塘口</th-ex>
            <th-ex v-if="order.pond == ''">周期</th-ex>
            <!-- <th-ex>费用类目</th-ex> -->
            <th-ex>费用名称</th-ex>
            <th-ex>金额(元)</th-ex>
            <th-ex>备注</th-ex>
          </thead-ex>
          <tbody-ex>
            <tr-ex
              v-for="(item, index) in order.details"
              :key="index"
              @selected="selectedRow = item"
            >
              <td-ex
                v-if="order.pond == ''"
                v-model="item.pondId"
                :editable="item.pondEdit"
                :list="fishPondList"
                display="value"
                take="key"
                type="cmb"
                @selected="onRowPondSelected(item)"
              ></td-ex>
              <td-ex
                v-if="order.pond == '' && !orderId"
                :key="`batch-${index}-${item.pondId}-${item.batchResetKey || 0}`"
                v-model="item.fishBatchId"
                :list="item.batchList"
                display="value"
                take="key"
                type="cmb"
                @selected="batchChange(item)"
              ></td-ex>
              <td-ex
                v-if="order.pond == '' && orderId"
                v-model="item.fishBatch"
                :editable="false"
                type="text"
              ></td-ex>
              <!-- <td-ex
                v-model="item.costCategoryId"
                type="cmb"
                :list="expenseTypeName"
                display="name"
                take="id"
                @selected="expenseTypeNameChange(item)"
              ></td-ex> -->
              <td-ex
                v-model="item.costTypeId"
                type="cmb"
                :list="costTypeV3List"
                isLevel
                levelName="details"
                display="name"
                take="id"
                @selected="expenseNameChange(item)"
              ></td-ex>
              <td-ex
                v-model="item.amount"
                type="number"
                number
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                @input="itemAmountInput"
              ></td-ex>
              <td-ex
                v-model="item.remark"
                type="input"
              ></td-ex>
            </tr-ex>
          </tbody-ex>
          <tfoot-ex v-model="order.remark" @addRow="addRow" @delRow="delRow">
            <td>合计</td>
            <td v-if="order.pond == ''">--</td>
            <td v-if="order.pond == ''">--</td>
            <!-- <td>--</td> -->
            <td>--</td>
            <td>{{ total("amount") }}</td>
            <td>--</td>
          </tfoot-ex>
        </table-ex>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "addExpenseRecord",
  mixins: [mixins],
  data() {
    return {
            // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      addBaseList: true,
      editBaseList: false,
      num: 3,
      show: false,
      delBtnDisable: true,
      addBtnDisable: true,
      alterBtnDisable: true,
      saveBtnDisable: false,
      rollBackBtnDisable: false,
      closeBtnDisable: false,
      orderId: this.$route.query.id,
      order: {
        fishBaseId: null,
        dataDate: new Date(),
        number: 0,
        pond: "",
        fishBatch: "",
        fishBatchId: "",
        remark: "",
        details: [],
        employeeId: null,
        price: 0,
        costTypeId: null,
        type: 1 // 费用类型 1-支出 2-收入
      },
      baseLists: [], //基地列表
      fishPondList: [], //塘口
      topPondList: [],
      expenseTypeName: [],
      expenseNameList: [], //费用名称列表
      enableTable: false,
      selectedRow: null,
      emptyRow: {
        pondId: null,
        fishBatch: null,
        fishBatchId: null,
        batchList: [],
        costTypeId: null,
        costCategoryId: null,
        costCategoryName: "",
        costTypeName: "",
        amount: 0,
        rate: 0,
        remark: "",
      },
      pondBatchList: [],
      // 负责人列表
      employeesList: [],
      // 所有费用
      costTypeV3List: [],
      costTypeV2List: [],
      // 所有塘口
      allPondList: [],
      // 是否禁用费用选择
      isDisCost: false,
    };
  },
  async mounted() {
    await this.initPagePermission();
    if (this.$route.query.id) {
      document.title = this.edit ? "编辑费用管理" : "查看费用管理";
    } else {
      document.title = "增加费用管理";
    }
    let result = await this.getBaseList();

    this.baseLists = result;
    let result1 = await this.getExpenseName({
      name: "",
      pid: 0,
      type: 1
    });
    this.expenseTypeName = result1; //类目

    let addFeedingBase = storage.get("base");
    let oldBase = this.baseLists.find((f) => f.key == addFeedingBase);
    if (addFeedingBase && oldBase) {
      this.order.fishBaseId = oldBase.key;
      await this.baseChange(this.order.fishBaseId);
    } else if (this.baseLists.length > 0) {
      this.order.fishBaseId = this.baseLists[0].key;
      await this.baseChange(this.order.fishBaseId);
    }
    // 获取负责人
    // 开始
    // this.employeesList = await this.getEmployees();
    // this.employeesList.unshift({
    //   id: "",
    //   mobilePhone: "",
    //   phone: "",
    //   realName: "全部",
    //   name: "全部",
    // });
    // 结束
    // 获取所有费用名称
    let costTypeV3 = await this.$api.getCostTypeV3(1);
    this.costTypeV3List = costTypeV3.data;
    let costTypeV2 = await this.$api.getCostTypeV2(1);
    this.costTypeV2List = costTypeV2.data.filter(
      (item) => item.details.length > 0
    );
    let allPond = await this.$api.getAllPondList();
    this.allPondList = allPond.data;
    this.initData(); //初始化表格
  },
  methods: {
    ...mapActions(modules.proofing, {
      getPondUnclearedBatchNo: "getPondUnclearedBatchNo", //周期批次
      getPondBatchList: "getPondBatchList",
    }),
    ...mapActions(modules.cultureCycle, {
      addFishBatch: "addFishBatch",
    }),
    ...mapActions(modules.expense, {
      getExpenseName: "getExpenseName", //费用名称
      addExpenseRecord: "addExpenseRecord", //添加费用
      updateExpenseRecord: "updateExpenseRecord", //修改
      getEditExpenseRecord: "getEditExpenseRecord", //编辑获取行数据
      delExpenseRecordAll: "delExpenseRecordAll", //删除
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond", //塘口
      getEditPondData: "getEditPondData", //获取塘口设置单行数据
    }),
    ...mapActions(modules.base, {
      getBaseList: "getBaseList", //基地
    }),
    ...mapActions({
      getSerialNumber: "getSerialNumber", //流水号
    }),
    ...mapActions(modules.user, ["getEmployees", "getEmployeesByFishBase"]), //获取负责人数据
    ...mapActions(['delVisitedViews']),
    // 获取当前基地下的负责人员工列表
    async getEmployeesByFishBaseList(){
      const result = await this.getEmployeesByFishBase(this.order.fishBaseId)
      this.employeesList = result;
      this.employeesList.unshift({
        id: "",
        mobilePhone: "",
        phone: "",
        realName: "全部",
        name: "全部",
      });
      if(this.orderId) return
      this.order.employeeId = result[0].id;
    },
    //总计
    total(prop) {
      let total = 0;
      this.order.details.forEach((item) => (total += Number(item[prop])));
      return total.toFixed(2);
    },
    isAllEqual(array, val) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value[val] !== array[0][val];
        });
      } else {
        return true;
      }
    },
    //初始化表格
    initTable() {
      this.order.details = [];
      this.$nextTick(() => this.addRow());
    },
    //初始化数据
    async initData() {
      if (!this.orderId) {
        //新增
        this.order.number = await this.getSerialNumber();
        this.topPondList = await this.getFishPond(this.order.fishBaseId);
        this.topPondList.unshift({
          key: "",
          value: "全部",
        });
        this.initTable();
      } else {
        //修改
        let result = await this.getEditExpenseRecord(this.orderId);
        this.order.fishBaseId = result.fishBaseId;
        this.order.employeeId = result.chargePersonId;
        if (this.order.employeeId) {
          this.fishPondList = this.allPondList;
        } else {
          await this.baseChange(result.fishBaseId);
        }
        // 判断是不是同一个费用
        let isSomeCostType = this.isAllEqual(result.details, "costTypeId");
        if (isSomeCostType) {
          this.$nextTick(() => {
            this.order.costTypeId = result.details[0].costTypeId;
            this.order.employeeId = result.chargePersonId;
          });
          this.isDisCost = false;
        } else {
           this.$nextTick(() => {
            this.order.employeeId = result.chargePersonId;
          });
          this.isDisCost = true;
        }
        result.details.forEach(async (item) => {
          item.amount = item.amount.toFixed(2);
          item.pondEdit = false;
          item.fishEdit = false;
          item.fishBatch = item.batchNo;
          this.expenseNameList = await this.getExpenseName({
            name: "",
            pid: item.costCategoryId,
            type: 1
          });
          let a = this.expenseNameList.find((f) => f.id == item.costTypeId);
          if (a) {
            item.costTypeName = a.name;
            item.costTypeId = a.id.toString();
          }
        });
        this.order = result;
        this.orderId = result.costId;
        this.topPondList = await this.getFishPond(result.fishBaseId);
        this.topPondList.unshift({
          key: "",
          value: "全部",
        });
        if (result.fishPondId === null) {
          this.order.pond = "";
        } else {
          this.order.pond = result.fishPondId;
          this.order.fishBatch = result.details[0].batchNo;
          this.order.fishBatchId = result.details[0].fishBatchId;
        }
      }
      this.enableTable = true;
    },
    //改变基地数据
    async baseChange(e) {
      storage.set("base", e);
      this.getFishPond(e)
        .then((data) => {
          this.fishPondList = data
          // this.fishPondList = [
          //   {
          //     key: 0,
          //     value: "全部",
          //   },
          // ].concat(data);
          if (this.fishPondList.length === 0) {
            this.$Alert.info({
              content: "当前选择的基地下面无塘口，请先添加",
              duration: 5000,
              status: "error",
            });
          }
        })
        .catch(() => {});

      this.order.details.forEach((f) => {
        f.pondId = null;
        f.fishBatchId = null;
        f.fishBatch = null;
        f.batchList = [];
      });
      if (!this.orderId) {
        this.topPondList = await this.getFishPond(e);
        this.order.pond = "";
        this.order.fishBatch = "";
        this.order.fishBatchId = "";
        this.pondBatchList = [];
        this.topPondList.unshift({
          key: "",
          value: "全部",
        });
      }
    },
    //费用类目数据
    async expenseTypeNameChange(e) {
      if (e.costCategoryId) {
        let item = this.expenseTypeName.find((f) => f.id == e.costCategoryId);
        if (item) {
          e.costCategoryName = item.name;
        }
        this.expenseNameList = await this.getExpenseName({
          name: "",
          pid: e.costCategoryId,
          type: 1
        });
      } else {
        //当什么都没有选中，则清理
        e.costCategoryId = null;
        e.costCategoryName = null;
        return;
      }
    },
    //费用名称数据
    async expenseNameChange(e) {
      if (!e.costTypeId) {
        //当什么都没有选中，则清理
        e.costTypeId = null;
        e.costTypeName = null;
        return;
      }
      // this.costTypeV3List.map((item) => {
      //   let ytem = item.details.find((f) => f.id == e.costTypeId);
      //   if (ytem) {
      //     e.costTypeName = ytem.name;
      //     e.costTypeId = ytem.id;
      //   }
      // });
      // this.order.details.map((item) => {
      //   item.costTypeId = e.costTypeId;
      //   item.costTypeName = e.costTypeName;
      // });
      // console.log(this.order.details);
      let item = this.costTypeV3List.find((f) => f.id == e.costTypeId);
      if (item) {
        e.costTypeName = item.name;
      }
    },
    async loadPondBatchList(pondId) {
      if (!pondId) return [];
      const result = await this.getPondBatchList(pondId);
      return (result || []).map((item) => ({
        key: item.key,
        value: String(item.value),
      }));
    },
    applyDefaultBatch(batchList, uncleared) {
      if (uncleared) {
        return { fishBatchId: uncleared.key, fishBatch: uncleared.value };
      }
      if (batchList && batchList.length > 0) {
        return { fishBatchId: batchList[0].key, fishBatch: batchList[0].value };
      }
      return { fishBatchId: "", fishBatch: "" };
    },
    headerBatchChange(batchId) {
      const item = this.pondBatchList.find((f) => f.key == batchId);
      this.order.fishBatch = item ? item.value : "";
      this.order.fishBatchId = batchId;
    },
    batchChange(row) {
      const item = (row.batchList || []).find((f) => f.key == row.fishBatchId);
      row.fishBatch = item ? item.value : "";
    },
    // 选择塘口
    async topPondChange(e) {
      if (e > 0) {
        const pondId = e;
        this.order.fishBatch = "";
        this.order.fishBatchId = "";
        this.pondBatchList = [];

        let { data: getEditPondDataResult} = await this.getEditPondData(e);
        if (this.order.pond !== pondId) return;

        this.order.employeeId = getEditPondDataResult.leaderId
        this.pondBatchList = await this.loadPondBatchList(e);
        if (this.order.pond !== pondId) return;

        let uncleared = await this.getPondUnclearedBatchNo(e);
        if (this.order.pond !== pondId) return;

        if (this.pondBatchList.length === 0 && !uncleared) {
          try {
            await MessageBox.confirm(
              "当前塘口尚未开启新的养殖周期，是否开启？",
              "提示"
            );
            try {
              await this.addFishBatch({
                fishPondId: e,
                batch: 0,
                startDate: this.order.dataDate,
              });
              if (this.order.pond !== pondId) return;

              this.pondBatchList = await this.loadPondBatchList(e);
              uncleared = await this.getPondUnclearedBatchNo(e);
              if (this.order.pond !== pondId) return;
            } catch (error) {
              this.order.pond = "";
              this.order.fishBatch = "";
              this.order.fishBatchId = "";
              this.pondBatchList = [];
              this.$Alert.info({
                content: "开启新周期失败",
                duration: 5000,
                status: "error",
              });
              return;
            }
          } catch (error) {
            this.order.pond = "";
            this.order.fishBatch = "";
            this.order.fishBatchId = "";
            this.pondBatchList = [];
            return;
          }
        }
        if (this.order.pond !== pondId) return;

        const selected = this.applyDefaultBatch(this.pondBatchList, uncleared);
        this.order.fishBatch = selected.fishBatch;
        this.order.fishBatchId = selected.fishBatchId;
      } else {
        this.order.fishBatch = "";
        this.order.fishBatchId = "";
        this.pondBatchList = [];
      }
    },
    clearRowBatch(row) {
      row.fishBatchId = null;
      row.fishBatch = "";
      row.batchList = [];
      row.batchResetKey = (row.batchResetKey || 0) + 1;
    },
    onRowPondSelected(row) {
      this.pondChange(row);
    },
    //改变塘口--联动周期
    async pondChange(row) {
      if (!row.pondId) {
        //当什么都没有选中，则清理
        this.clearRowBatch(row);
        row.fishBatchId = 0;
        row.fishBatch = 0;
        return;
      }
      if (row.pondId != -1) {
        const pondId = row.pondId;
        this.clearRowBatch(row);

        row.rate = this.fishPondList.find( pond => pond.key == row.pondId).rate
        row.batchList = await this.loadPondBatchList(row.pondId);
        if (row.pondId !== pondId) return;

        let uncleared = await this.getPondUnclearedBatchNo(row.pondId);
        if (row.pondId !== pondId) return;

        if (row.batchList.length === 0 && !uncleared) {
          try {
            await MessageBox.confirm(
              "此塘口已清塘，是否开启新的养殖周期？",
              "提示"
            );
            try {
              await this.addFishBatch({
                fishPondId: row.pondId,
                batch: 0,
                startDate: this.order.dataDate,
              });
              if (row.pondId !== pondId) return;

              row.batchList = await this.loadPondBatchList(row.pondId);
              uncleared = await this.getPondUnclearedBatchNo(row.pondId);
              if (row.pondId !== pondId) return;
            } catch (error) {
              row.pondId = null;
              this.clearRowBatch(row);
              this.$Alert.info({
                content: "开启新周期失败",
                duration: 5000,
                status: "error",
              });
              return;
            }
          } catch (error) {
            row.pondId = null;
            this.clearRowBatch(row);
            return;
          }
        }
        if (row.pondId !== pondId) return;

        const selected = this.applyDefaultBatch(row.batchList, uncleared);
        row.fishBatchId = selected.fishBatchId;
        row.fishBatch = selected.fishBatch;
      } else {
        row.fishBatchId = 0;
        row.fishBatch = 0;
        row.batchList = [];
      }
    },
    // 选择负责人
    changeEmlopyee(e) {
      // 已选表头塘口时只改负责人（v-model 已更新），不清空明细、不按员工重拉多塘口分摊
      if (this.order.pond != "") {
        return;
      }
      this.fishPondList = []
      this.getPondListByEmployee(e);
      this.order.costTypeId = "";
      this.order.price = 0;
      this.order.details.map((item) => {
        item.pondId = "";
        item.fishBatch = "";
        item.fishBatchId = "";
        item.batchList = [];
        item.rate = 0;
        item.costTypeId = "";
        item.amount = "";
      });
      // this.fishPondList = this.allPondList;
    },
    // 根据员工ID，获取对应员工底下塘口Id和塘口面积
    async getPondListByEmployee(id) {
      let res = await this.$api.getPondListByEmployee(id, this.order.fishBaseId);
      let list = res.data.list;
      this.fishPondList = list.map(pond => {
        return { 
          key: pond.pondId, 
          value: this.allPondList.find( item => item.key == pond.pondId).value,
          rate: pond.rate,
          pondArea:pond.pondArea 
        }
      })
      if (list.length > 0) {
        const need = list.length - this.order.details.length;
        if (need > 0) {
          for (let i = 0; i < need; i++) {
            this.order.details.push(JSON.parse(JSON.stringify(this.emptyRow)));
          }
        }
        list.map((item, index) => {
          this.$nextTick(async () => {
            this.order.details[index].pondId = item.pondId;
            this.order.details[index].rate = item.rate;
            this.order.details[index].batchList = await this.loadPondBatchList(item.pondId);
            this.order.details[index].fishBatch = item.fishBatchValue;
            this.order.details[index].fishBatchId = item.fishBatchId;
          });
        });
      } else {
        this.fishPondList = [];
      }
    },

    // 选择费用名称
    changeCostType(e) {
      this.order.details.map((item) => {
        if (item.pondId) {
          item.costTypeId = e;
          item.costCategoryId = this.costTypeV3List.find(
            (item) => item.id == e
          ).pid;
          item.costCategoryName = "其他";
          item.costTypeName = this.costTypeV3List.find(
            (item) => item.id == e
          ).name;
        }
        // item.costTypeName = "xx";
      });
    },
    // 重计算列表金额，获取金额失去焦点
    calculateDetailAmount() {
      let pondAreaSum=0;
      let pondAreaCount=0;
      this.order.details.forEach((detail)=> {
        if(detail.pondId){
         pondAreaSum += this.fishPondList.find( t => t.key == detail.pondId).pondArea
         pondAreaCount++;
        }
      })
      
      let orderTotalAmount = this.order.price && Number(this.order.price)
      let curSum = 0
      this.order.details.map((item) => {
        if (item.pondId) {
          let curPondArea = this.fishPondList.find( t => t.key == item.pondId).pondArea
          let newRate = pondAreaSum ?curPondArea/pondAreaSum : 1/pondAreaCount
          console.log('进来了', item.rate,newRate, item.pondId, item.amount)
          item.amount = (newRate * this.order.price).toFixed(2);
          curSum = Number(curSum) + Number(item.amount)
        }
      });

     if(orderTotalAmount && orderTotalAmount > 0){
        if(orderTotalAmount != curSum){
          const diffAmount = (orderTotalAmount - curSum).toFixed(2);
          let item = this.order.details.find(c => c.pondId && c.amount && c.amount > 0);
          if(item && (Number(item.amount) + Number(diffAmount)) > 0){
            item.amount = (Number(item.amount) + Number(diffAmount)).toFixed(2)
          }
        }
      }
    },
    //保存
    async onSave() {
      let err = null;
      if (!this.order.fishBaseId) err = "基地必须选择";
      if (!this.order.dataDate) err = "日期必须选择";
      if (!this.order.employeeId) err = "负责人必须选择";
      if (this.order.pond && !this.order.fishBatchId) err = "周期必须选择";
      // if (!this.order.costTypeId) err = "费用名称必须选择";
      // let list = this.order.details.filter(
      //   f => JSON.stringify(f) != JSON.stringify(this.emptyRow)
      // );
      // let list = this.order.details.filter(f => {
      //   return f.pondId !== "" && f.pondId !== null;
      // });
      this.order.chargePersonId = this.order.employeeId;
      let list = [];
      if (this.order.pond == "") {
        list = this.order.details.filter((f) => {
          return f.pondId !== "" && f.pondId !== null;
        });
      } else {
        list = this.order.details.filter((f) => {
          return f.costTypeId !== "" && f.costTypeId !== null;
        });
        list.map((item) => {
          item.pondId = this.order.pond;
          item.fishBatch = this.order.fishBatch;
          item.fishBatchId = this.order.fishBatchId;
          // 表头单塘口时占比为 1，避免 rate 空字符串导致后端 Decimal 反序列化失败
          if (item.rate === "" || item.rate === null || item.rate === undefined) {
            item.rate = 1;
          }
        });
      }

      if (list.length == 0) err = "不能提交空表单";

      list.forEach((item) => {
        let amountReg = /^[0-9]{1,12}([.][0-9]{1,2})?$/; //金额
        if (!amountReg.test(item.amount)) {
          err = "金额范围至多12位正整数,2位小数";
        }
        if (item.amount === 0) {
          err = "请输入金额";
        }
        if (!item.fishBatchId) err = "周期必须选择";
        if (item.costTypeId == null) err = "费用名称必须选择";
        // 兜底：rate 不能传空字符串，后端 CostDetailDto.Rate 为 decimal
        if (item.rate === "" || item.rate === null || item.rate === undefined) {
          item.rate = 0;
        }
      });

      if (err) {
        Message.error(err);
        return;
      }

      try {
        if (list.length > 0) {
          this.order.details = list;
        }
        this.enableTable = false;
        this.$nextTick(async () => {
          if (this.orderId) {
            this.order.costId = this.orderId;

            await this.updateExpenseRecord(this.order);
            this.$message({
              message: "保存成功",
              type: "success",
            });
          } else {
            let result = await this.addExpenseRecord(this.order);
            this.orderId = result.orderId;
            // this.costTypeName =
            this.$message({
              message: "保存成功",
              type: "success",
            });
          }
          this.enableTable = false;
        });
      } catch (error) {
        this.enableTable = true;
        this.$Alert.info({
          content: error.response.data,
          duration: 5000,
          status: "error",
        });
        // Message.error(error.response.data);
      }
    },
    onAlter() {
      this.enableTable = true;
      this.edit = true;
      if (this.orderId) {
        this.order.details.forEach((item) => {
          item.pondEdit = false;
          item.fishEdit = false;
        });
      }
    },
    onAdd() {
      this.order.billsNo = 0;
      this.orderId = null;
      this.enableTable = true;
      this.$nextTick(() => this.initData());
    },
    async onDelete() {
      if (!this.orderId) {
        await this.$Alert.info({
          content: "未找到订单Id，无法删除",
          duration: 5000,
          status: "error",
        });
        // await Message.error("未找到订单Id，无法删除");
        return;
      }
      try {
        await MessageBox.confirm("是否删除此订单？", "提示");
        try {
          await this.delExpenseRecordAll(this.orderId);
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.delId = null;
          this.$nextTick(() => this.initTable());
          this.enableTable = true;
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error",
          });
          // this.$message.error(error.response.data);
        }
      } catch (err) {
        console.log("取消删除");
      }
    },
    onRollBack() {
      this.initData();
      this.edit = false
      this.enableTable = false
    },
    addRow() {
      let list = [];
      for (let i = 0; i < 5; i++) {
        list.push(JSON.parse(JSON.stringify(this.emptyRow)));
      }
      this.order.details = this.order.details.concat(list);
      // this.calculateDetailAmount()
    },
    delRow() {
      this.order.details = this.order.details.filter(
        (f) => f != this.selectedRow
      );
      //this.itemAmountInput()
      // this.calculateDetailAmount()
    },
    closeView(){
      this.delVisitedViews([{
        meta: { affix: false },
        path: this.$route.path,
        title: this.$route.meta.title,
      }])
      this.$router.replace('/expense/ExpenseRecord')
    },
    itemAmountInput(){
      this.order.price = this.total("amount")
    }
  },
  watch: {
    'order.fishBaseId'() {
      this.getEmployeesByFishBaseList()
    }
  }
};
</script>
<style >
.addExpenseRecord .add-content-container,
.addExpenseRecord .add-titieMain {
  /* height: 190px; */
}
.addExpenseRecord .add-content-container .add-titieMain .add-content {
  /* height: 150px; */
}
.addExpenseRecord .custom-search-container {
  margin-top: 25px;
}
.addExpenseRecord .custom-search-container .custom-search-box > .custom-search-box-warpper:first-child {
  box-sizing: border-box;
  flex: 0 0 448px;
  width: 448px;
}
.addExpenseRecord .custom-search-container .custom-search-box.has-pond > .custom-search-box-warpper:first-child {
  flex: 0 0 596px;
  width: 596px;
}
.danger-color {
  color: #fff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}
/* .readonlys input {
  pointer-events: none;
  background: #f5f7fa;
} */

.base-search-box-wrapper {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.base-search-box .base-pond-box {
  margin-left: 20px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.base-search-box .header-date-wrapper {
  margin-left: 0;
}

.base-search-box .base-pond-box .header-batch-area {
  display: inline-flex;
  align-items: center;
  width: 0;
  overflow: hidden;
  flex-shrink: 0;
}
.base-search-box.has-pond .base-pond-box .header-batch-area {
  width: 148px;
}

.base-search-box .base-pond-box .header-pond-select .el-input {
  width: 150px !important;
  min-width: 150px !important;
}
.base-search-box .base-pond-box .header-batch-label {
  color: #333;
  margin-left: 12px;
  white-space: nowrap;
}
.base-search-box .base-pond-box .header-batch-select {
  width: 96px !important;
  margin-left: 8px;
}
.base-search-box .base-pond-box .header-batch-select .el-input,
.base-search-box .base-pond-box .header-batch-select .el-input--small {
  width: 96px !important;
  min-width: 96px !important;
}
.base-search-box .base-pond-box .header-batch-text {
  color: #333;
  margin-left: 8px;
}
.addExpenseRecord .table-container .table-package th-ex:nth-child(3),
.addExpenseRecord .table-container .table-package td.tableUnit:nth-child(3) {
  min-width: 96px;
}
</style>
